import Const from 'const';

function createLineupPlayerMap(lineups) {
    const map = {
        lineups: {},
        players: {},
    };

    Object.values(lineups.all()).map((lineup) => {
        // @ts-ignore
        const {lineupId, players} = lineup;

        map.lineups[lineupId] ??= {};

        Object.values(players).map((player) => {
            // @ts-ignore
            const {playerId, positionInLineup} = player;

            map.lineups[lineupId][playerId] = true;

            map.players[playerId] ??= {
                [Const.OVERALL_MODE]: {},
            };

            map.players[playerId][Const.OVERALL_MODE][lineupId] = true;
            map.players[playerId][positionInLineup] ??= {};
            map.players[playerId][positionInLineup][lineupId] = true;
        });
    });

    return map;
}

function createLineupPlayerMapByLineupRoles(lineups) {
    const map = {
        lineups: {},
        players: {},
    };

    Object.values(lineups.all()).map((lineup) => {
        // @ts-ignore
        const {lineupId, players} = lineup;

        map.lineups[lineupId] ??= {};

        Object.values(players).map((player) => {
            // @ts-ignore
            const {playerId, lineupRole} = player;

            map.players[playerId] ??= {};
            map.players[playerId][lineupRole] ??= {};

            map.lineups[lineupId][playerId] = true;
            map.players[playerId][lineupRole][lineupId] = true;
        });
    });

    return map;
}

export {createLineupPlayerMap, createLineupPlayerMapByLineupRoles};
